import { read_u16, Sink } from "../../helpers/serializerHelpers";

export class OrientationData {
    public error: number = 0;
    public accelX: number = 0;
    public accelY: number = 0;
    public accelZ: number = 0;
    public pitch: number = 0;
    public roll: number = 0;

    public deserialize(bytes: Sink) {
        this.error = read_u16(bytes);
        this.accelX = read_u16(bytes);
        this.accelY = read_u16(bytes);
        this.accelZ = read_u16(bytes);
        this.pitch = read_u16(bytes);
        this.roll = read_u16(bytes);
        return this;
    }
}
